import PickerPage from '../../../src/client/pages/choosable/pages/picker';

export default PickerPage;
